import React from 'react';
import {Checkbox, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {IStep} from "../DigitalSign";

export interface IConsentStep {
    step: IStep;
    setStep?: (step: IStep) => void;
}

const ConsentStep = (props: IConsentStep) => {
    const {t} = useTranslation(['network']);
    const width = window.innerWidth * 80 / 100;
    const handleChoosing = (e: any, value: string) => {
        if (props.setStep === undefined) return;
        props.setStep({
            ...props.step,
            options: {
                ...props.step.options,
                [e.target.name]: value === 'true'
            }
        });
    }
    const handleChecking = (e: any, checked: boolean) => {
        if (props.setStep === undefined) return;
        props.setStep({
            ...props.step,
            options: {
                ...props.step.options,
                [e.target.name]: checked
            }
        });
    }

    return (
        <Grid container sx={{width: width, marginTop: '16px'}}>
            <Grid item xs={12} mb={2}>
                <Typography variant={'h6'} >{t(`digitalSign.consent.hint`)}</Typography>
            </Grid>
            <Grid item xs={12}>
                <FormLabel id={'ntw_consent_viewInfoAck'}>{t(`digitalSign.consent.viewInfoAck`)}</FormLabel>
                <RadioGroup
                    row
                    aria-labelledby='ntw_consent_viewInfoAck'
                    onChange={handleChoosing}
                    //non recuperare i dati dall'url perché deve essere scelto ogni volta
                    //defaultValue={props.step.options?.viewInfoAck}
                    name={'viewInfoAck'}
                >
                    <FormControlLabel value={'true'} control={<Radio/>}
                                      label={t(`digitalSign.consent.option.yes`)}/>
                    <FormControlLabel value={'false'} control={<Radio/>}
                                      label={t(`digitalSign.consent.option.no`)}/>
                </RadioGroup>
            </Grid>
            <Grid item xs={12}>
                <FormControlLabel
                    name={"promoOthersConsent"}
                    onChange={handleChecking}
                    control={<Checkbox defaultChecked={!!props.step.options?.promoOthersConsent}/>}
                    label={t(`digitalSign.consent.promoOthersConsent`)}/>
            </Grid>
            <Grid item xs={12}>
                <FormControlLabel
                    name={"preferenciesConsent"}
                    onChange={handleChecking}
                    control={<Checkbox defaultChecked={!!props.step.options?.preferenciesConsent}/>}
                    label={t(`digitalSign.consent.preferenciesConsent`)}/>
            </Grid>
            <Grid item xs={12}>
                <FormControlLabel
                    name={"promoDrivaliaConsent"}
                    onChange={handleChecking}
                    control={<Checkbox defaultChecked={!!props.step.options?.promoDrivaliaConsent}/>}
                    label={t(`digitalSign.consent.promoDrivaliaConsent`)}/>
            </Grid>
        </Grid>
    )
};

export default ConsentStep;